const CityTributation = () => import('./pages/CityTributation.vue');

export default [
  {
    path: '/fiscal/city-tributation',
    name: 'CityTributation',
    component: CityTributation,
    meta: {
      title: 'Alíquotas municipais (IBS)',
    },
  },
];
